import { BrowserModule, Title } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { I18nModule } from 'src/app/modules/i18n/i18n.module';



import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SharedModule } from './modules/shared/shared.module';
import { NotFoundComponent } from './screens/not-found/not-found.component';
import { AboutUsComponent } from './screens/about-us/about-us.component';
import { TermsConditionsComponent } from './screens/terms-conditions/terms-conditions.component';
import { DisclaimerComponent } from './screens/disclaimer/disclaimer.component';
import { CopyrightPolicyComponent } from './screens/copyright-policy/copyright-policy.component';
import { PrivacyPolicyComponent } from './screens/privacy-policy/privacy-policy.component';
import { ContactUsComponent } from './screens/contact-us/contact-us.component';
import { HyperlinkPolicyComponent } from './screens/hyperlink-policy/hyperlink-policy.component';
import { TokenInterceptor } from 'src/app/modules/interceptors/token.interceptor';
import { FaqComponent } from './screens/faq/faq.component';
import { RecaptchaModule } from "ng-recaptcha";
import {OurPartnerComponent} from "./screens/our-partner/our-partner.component"


@NgModule({
  declarations: [
    AppComponent,
    NotFoundComponent,
    AboutUsComponent,
    TermsConditionsComponent,
    DisclaimerComponent,
    CopyrightPolicyComponent,
    PrivacyPolicyComponent,
    ContactUsComponent,
    HyperlinkPolicyComponent,
    FaqComponent,
    OurPartnerComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    SharedModule,
    HttpClientModule,
    I18nModule,
    RecaptchaModule,
  ],
  providers: [
    Title,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
